/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ExtensionOrderImportItemDTO interface.
 */
export function instanceOfExtensionOrderImportItemDTO(value) {
    if (!('orderId' in value) || value['orderId'] === undefined)
        return false;
    return true;
}
export function ExtensionOrderImportItemDTOFromJSON(json) {
    return ExtensionOrderImportItemDTOFromJSONTyped(json, false);
}
export function ExtensionOrderImportItemDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderId': json['orderId'],
        'buyerName': json['buyerName'] == null ? undefined : json['buyerName'],
        'company': json['company'] == null ? undefined : json['company'],
        'address': json['address'] == null ? undefined : json['address'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'addressLine': json['addressLine'] == null ? undefined : json['addressLine'],
        'city': json['city'] == null ? undefined : json['city'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'state': json['state'] == null ? undefined : json['state'],
    };
}
export function ExtensionOrderImportItemDTOToJSON(json) {
    return ExtensionOrderImportItemDTOToJSONTyped(json, false);
}
export function ExtensionOrderImportItemDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderId': value['orderId'],
        'buyerName': value['buyerName'],
        'company': value['company'],
        'address': value['address'],
        'phone': value['phone'],
        'addressLine': value['addressLine'],
        'city': value['city'],
        'postalCode': value['postalCode'],
        'countryCode': value['countryCode'],
        'state': value['state'],
    };
}
